export const criminalOptions = [
  { value: 'פלילי-כללי', label: 'פלילי-כללי', color: '#00B8D9', isFixed: true },
  { value: 'צווארון כחול', label: 'צווארון כחול', color: '#0052CC', isDisabled: false },
  { value: 'צווארון לבן', label: 'צווארון לבן', color: '#5243AA' },
  { value: 'תעבורה', label: 'תעבורה', color: '#FF5630', isFixed: true },
];

export const commecrialOptions = [
  { value: 'בנקאות ומימון', label: 'בנקאות ומימון', rating: 'safe' },
  { value: 'היי-טק', label: 'היי-טק', rating: 'good' },
  { value: 'זיכיונות', label: 'זיכיונות', rating: 'wild' },
  { value: 'מיסים', label: 'מיסים', rating: 'crazy' },
  { value: 'קניין רוחני', label: 'קניין רוחני', rating: 'crazy' },
  { value: 'מחשבים ואינטרנט', label: 'מחשבים ואינטרנט', rating: 'crazy' },
  { value: 'הגבלים עסקיים', label: 'הגבלים עסקיים', rating: 'crazy' },
  { value: 'מיזוגים ורכישות', label: 'מיזוגים ורכישות', rating: 'crazy' },
  { value: 'יזמות עסקית והשקעות', label: 'יזמות עסקית והשקעות', rating: 'crazy' },
  { value: 'שוק ההון', label: 'שוק ההון', rating: 'crazy' },
  { value: 'תקשורת', label: 'תקשורת', rating: 'crazy' },
  { value: 'חברות', label: 'חברות', rating: 'crazy' },
  { value: 'מימון', label: 'מימון', rating: 'crazy' },
];

export const locationOptions = [
  { value: 'ת"א, גוש דן, השרון', label: 'ת"א, גוש דן, השרון'},
  { value: 'חיפה, נהריה', label: 'חיפה, נהריה'},
  { value: 'הגליל וצפונה', label: 'הגליל וצפונה'},
  { value: 'באר שבע והסביבה', label: 'באר שבע והסביבה'},
  { value: 'ירושלים והסביבה', label: 'ירושלים והסביבה'},
  { value: 'אילת והערבה', label: 'אילת והערבה'},
  { value: 'נתניה, חדרה', label: 'נתניה, חדרה'},
  { value: 'עפולה והסביבה', label: 'עפולה והסביבה'},
  { value: 'אשדוד, רחובות', label: 'אשדוד, רחובות'},
];

export const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
export const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center",
};

export const groupedOptions = [
  {
    label: 'פלילי',
    options: criminalOptions,
  },
  {
    label: 'מסחרי',
    options: commecrialOptions,
  },
];
